

<div class="ttmodal" style="min-width: 50vw;">
  <div class="ttmodal__header" style="margin-bottom: 15px">
      <span class="ttmodal__title">{{'Product Improvement' | translate | async}}</span>
<!--            
        <button   class="button button--primary" (click)="getCurrentUserAlertsforDashboard()"><span class="button__text"
            >Alerts (Current)</span></button>
       <button   class="button button--primary" (click)="getHistoryUserAlertsforDashboard()"><span class="button__text"
            >Alert History</span></button> -->

           
            


      <i class="material-icons ttmodal__close-button"  (click)="onCloseClick()">close</i>
  </div>


  <mat-tab-group>
      <mat-tab label="Alerts (Current)">
        
      <div  style="overflow-y: auto; height:350px; ">
        <table class="table table--striped table--full-width">
            <thead>             
                <th style="text-align: center;">{{'Source' | translate | async}}</th>
                <th style="text-align: center;">{{'Created Date' | translate | async}}</th>
                <th style="text-align: center;">{{'Description' | translate | async}}</th>

                <th style="text-align: center;">{{'Link' | translate | async}}</th>
                <th style="text-align: center;">{{'Move to History' | translate | async}}</th>            
              
            </thead>
            <ng-container *ngFor="let alert of userAlertslist">
            <tbody>
              <tr *ngIf="alert.status==1">
              
                <td style="text-align: center; cursor: pointer;" >{{alert.Source}}</td>
                <td style="text-align: center; cursor: pointer;" >{{alert.CreatedDate | date:'dd MMM yyyy'}}</td>
                <td  style="text-align: center; cursor: pointer;">{{alert.description}} </td>
                <td style="text-align: center; cursor: pointer;"(click)="openProdImprovementAssetScreen(alert.Link);"><a>{{alert.ImpName}} {{alert.EqUnitNo}}</a></td>    
                <td style="text-align: center; cursor: pointer;">
                  <mat-checkbox  [checked]="alert.isHistory" (change)='checkboxChanged($event,alert.ID);'></mat-checkbox>
                </td>           
  
              </tr>
            </tbody>
            </ng-container>
        </table>
        </div>
      </mat-tab>
      <mat-tab label="Alert History">
        
        <div  style="overflow-y: auto; height:350px; ">
          <table class="table table--striped table--full-width">
              <thead>             
                  <th style="text-align: center;">{{'Source' | translate | async}}</th>
                  <th style="text-align: center;">{{'Created Date' | translate | async}}</th>
                  <th style="text-align: center;">{{'Description' | translate | async}}</th>

                  <th style="text-align: center;">{{'Link' | translate | async}}</th>
                  <th style="text-align: center;">{{'Move to Current' | translate | async}}</th>            

              </thead>
              <ng-container *ngFor="let alert of userAlertslist_">
              <tbody>
                <tr *ngIf="alert.status==2">
                
                  <td style="text-align: center; cursor: pointer;" >{{alert.Source}}</td>
                  <td style="text-align: center; cursor: pointer;" >{{alert.CreatedDate | date:'dd MMM yyyy'}}</td>
                  <td  style="text-align: center; cursor: pointer;">{{alert.description}} </td>
                  <td style="text-align: center; cursor: pointer;"(click)="openProdImprovementAssetScreen(alert.Link);"><a>{{alert.ImpName}} {{alert.EqUnitNo}}</a></td>  
                  <td style="text-align: center; cursor: pointer;">
                    <mat-checkbox  [checked]="alert.isHistory" (change)='checkboxChanged($event,alert.ID);'></mat-checkbox>
                  </td>           
    
                </tr>
              </tbody>
              </ng-container>
          </table>
          </div>
          <button  class="button button--primary" (click)="ClearHistory()"><span class="button__text"
            >Clear History</span></button>
        </mat-tab>
      </mat-tab-group>
      <!-- <div  style="overflow-y: auto; height:350px; ">
        <table class="table table--full-width table--striped" style="margin-top: 9px;">
        
          <thead>
            <tr>
              <th style="display: flex;flex-direction: row;justify-content: space-between;">
                <div style="display: flex;justify-content: left;">
                  <span
                    style="min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">Source</span>
  
                </div>
                <div style="display: flex;flex: 1;justify-content: center;">
                  <span
                    style="min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">Created Date</span>
                </div>
                <div style="display: flex;flex: 1;justify-content: left;">
                  <span
                    style="min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">Description</span>
                </div>

                <div style="display: flex;flex: 1;justify-content: left;">
                  <span
                    style="min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">Link
                    </span>
                </div>    
                <div style="display: flex;flex: 1;justify-content: left;">
                  <span
                    style="min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">Move to History
                    </span>
                </div>    
                
  
  
              </th>
            </tr>
          </thead>
          <ng-container *ngFor="let alert of userAlertslist">
           
            <tbody>
              <tr >
                <td style="min-width: 50px;display: flex;flex-direction: row;justify-content: space-between;">
    
                  <div style="display: flex;justify-content: left;">
                    <span 
                      style="cursor: pointer;min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{alert.Source}}</span>
                  </div>
                 
                  <div style="display: flex;flex: 1;justify-content: center;">
                    <span 
                      style="cursor: pointer;min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{alert.CreatedDate | date:'dd MMM yyyy'}}</span>
                  </div>
                  <div style="display: flex;flex: 1;justify-content: left;">
                    <span 
                      style="cursor: pointer;min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{alert.description}}</span>
                  </div>
  
                  <div style="display: flex;flex: 1;justify-content: center;"> 
                    <span (click)="openProdImprovementAssetScreen(alert.Link);"
                      style="cursor: pointer;min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{alert.Link}}</span>
                  </div>

                  <div style="display: flex;justify-content: left;">
                    <mat-checkbox  [checked]="alert.isHistory" (change)='checkboxChanged($event,alert.ID);'></mat-checkbox>
                  </div>
                  
                 
                </td>
              </tr>
            </tbody> 
          </ng-container>
        
          
        </table>
     
      </div> -->

 

</div>